import PickingSupplyForProductionDetail from '@/models/PickingSupplyForProduction/PickingSupplyForProductionDetail';

export default class PickingSupplyForProductionDetailFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.pickingSupplyForProductionId  = '';
		this.pickingSupplyForProductionWorkOrderSupply = '';
		this.materialPartId  = '';
		this.materialPartPartNumber = '';
		this.partId  = '';
		this.partPartNumber = '';
		this.qtySupply = '';
		this.qtyOutstanding = '';
		this.remarkMultiple = '';
		this.documentStatusId  = '';
		this.documentStatusName = '';
		this.workOrderSupplyDetailId  = '';
		this.workOrderSupplyDetailMaterialPart = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
		this.materialPartCombination = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			pickingSupplyForProductionId : '0',
			pickingSupplyForProductionWorkOrderSupply : '0',
			materialPartId : '0',
			materialPartPartNumber : '0',
			partId : '0',
			partPartNumber : '0',
			qtySupply : '0',
			qtyOutstanding : '0',
			remarkMultiple : '0',
			documentStatusId : '0',
			documentStatusName : '0',
			workOrderSupplyDetailId : '0',
			workOrderSupplyDetailMaterialPart : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}